<template>
  <div class="cover" :style="{minHeight: clientHeight}">
    <nav-header
      v-bind:showSearch="p_showSearch"
      v-bind:loginModalFlag="p_loginModalFlag"
      v-bind:showOrNot="p_showOrNot"
      v-on:showLoginModal="p_showLoginModal"
      v-on:closeLoginModal="p_closeLoginModal">
    </nav-header>
    <img class="banner banner-phone" src="../../assets/enter_banner_iphone_in.png" alt="">
    <img class="banner banner-pc" src="../../assets/enter_banner_pc_in.png" alt="">
    <div class="cover_in">
      <div class="wrap">
        <el-form :inline="true" :model="dataForm" ref="dataForm">
          <div class="explain_title">
            <span class="required_red">*</span>预出口国家
          </div>
          <el-form-item
            prop="exportCountry"
            :rules="[
              { required: true, message: '预出口国家不能为空' }
            ]">
            <el-select v-model="dataForm.exportCountry" filterable placeholder="请选择">
              <el-option-group
                v-for="item in cityList"
                :key="item.key"
                :label="item.key">
                <el-option
                  v-for="_item in item.data"
                  :key="_item"
                  :label="_item"
                  :value="_item">
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
          <div class="explain_title">
            <span class="required_red">*</span>预采购产品
          </div>
          <el-form-item
            prop="purchaseProducts"
            :rules="[
              { required: true, message: '预采购产品不能为空' }
            ]">
            <el-checkbox-group v-model="dataForm.purchaseProducts">
              <p
                v-for="(item,index) in productList"
                :key="item.label">
                <el-checkbox :label="item.label" @change="e => changeProduct(e, index)"></el-checkbox>
                <el-input type='number' v-model="item.value" :placeholder="item.placeholder" :disabled="dataForm.purchaseProducts.indexOf(item.label) === -1" @change="e => changeProductNum(e, index)"></el-input>
              </p>
            </el-checkbox-group>
          </el-form-item>
          <div class="explain_title">
            <span class="required_red">*</span>合作模式
          </div>
          <el-form-item
            prop="cooperationModel"
            :rules="[
              { required: true, message: '合作模式不能为空' }
            ]">
            <el-select v-model="dataForm.cooperationModel" placeholder="请选择">
              <el-option
                v-for="item in cooperationModels"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <template v-if="dataForm.cooperationModel">
            <div class="explain_title">
              采购公司信息
            </div>
            <el-form-item
              label="采购方类型"
              prop="cgType"
              :rules="[
              { required: true, message: '采购方类型不能为空' }
            ]">
              <el-select v-model="dataForm.cgType" placeholder="请选择">
                <el-option
                  v-for="item in purchasingType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="采购方名称"
              prop="cgCompanyName"
              :rules="[
              { required: true, message: '采购方名称不能为空' },
              { max: 30, message: '长度不能超过30个字符' }
            ]">
              <el-input v-model="dataForm.cgCompanyName" placeholder="请输入采购方名称"></el-input>
            </el-form-item>
            <el-form-item
              label="采购方所在地"
              prop="cgAddress"
              :rules="[
              { required: true, message: '采购方所在地不能为空' },
            ]">
              <el-cascader popper-class="cascaderClass" :options="provinceAndCityData" v-model="dataForm.cgAddress" filterable></el-cascader>
            </el-form-item>
            <el-form-item
              label="联系人"
              prop="cgName"
              :rules="[
              { required: true, message: '联系人不能为空' }
            ]">
              <el-input v-model="dataForm.cgName" placeholder="请输入联系人"></el-input>
            </el-form-item>
            <el-form-item
              label="手机"
              prop="cgMobile"
              :rules="[
              { required: true, message: '手机号不能为空' },
              { max: 20, message: '长度不能超过20个字符' }
            ]">
              <el-input v-model="dataForm.cgMobile" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item
              label="E-mail"
              prop="cgEmail"
              :rules="[
              { required: true, message: 'E-mail不能为空' }
            ]">
              <el-input v-model="dataForm.cgEmail" placeholder="请输入E-mail"></el-input>
            </el-form-item>
            <el-form-item
              label="营业执照"
              prop="list1"
            >
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="actionUrl"
                :headers="uploadHeader"
                :multiple="false"
                :before-upload="beforeUploadHandle"
                :on-success="successHandle1"
                :file-list="fileList1">
                <el-button icon="el-icon-upload2" class="btn-base">上传本地文件</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item
              label="医疗器械经营许可证"
              prop="list2"
            >
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="actionUrl"
                :headers="uploadHeader"
                :multiple="false"
                :before-upload="beforeUploadHandle"
                :on-success="successHandle2"
                :file-list="fileList2">
                <el-button icon="el-icon-upload2" class="btn-base">上传本地文件</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item
              label="进出口权资格证"
              prop="list3"
            >
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="actionUrl"
                :headers="uploadHeader"
                :multiple="false"
                :before-upload="beforeUploadHandle"
                :on-success="successHandle3"
                :file-list="fileList3">
                <el-button icon="el-icon-upload2" class="btn-base">上传本地文件</el-button>
              </el-upload>
            </el-form-item>
            <div class="el-upload__tip">支持pdf、jpg、gif、png格式；单张大小不超过10M</div>
          </template>
          <template v-if="dataForm.cooperationModel == 1">
            <div class="explain_title">
              目的国第一接受方信息
            </div>
            <el-form-item
              label="目的国第一接受方类型"
              prop="zdType"
              :rules="[
              { required: true, message: '采购方类型不能为空' }
            ]">
              <el-select v-model="dataForm.zdType" placeholder="请选择">
                <el-option
                  v-for="item in receivedType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              label="目的国第一接受方名称"
              prop="zdCompanyName"
              :rules="[
                { required: true, message: '目的国第一接受方名称不能为空' },
                { max: 30, message: '长度不能超过30个字符' }
              ]">
              <el-input v-model="dataForm.zdCompanyName" placeholder="请输入公司名称"></el-input>
            </el-form-item>

            <el-form-item
              label="联系人"
              prop="zdName"
            >
              <el-input v-model="dataForm.zdName" placeholder="请输入联系人"></el-input>
            </el-form-item>

            <el-form-item
              label="联系电话"
              prop="zdMobile"
            >
              <el-input v-model="dataForm.zdMobile" placeholder="请输入电话"></el-input>
            </el-form-item>
            <el-form-item
              label="E-mail"
              prop="zdEmail"
            >
              <el-input v-model="dataForm.zdEmail" placeholder="请输入邮箱"></el-input>
            </el-form-item>
            <el-form-item
              label="资质文件"
              prop="list4"
            >
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="actionUrl"
                :headers="uploadHeader"
                :multiple="false"
                :before-upload="beforeUploadHandle"
                :on-success="successHandle4"
                :file-list="fileList4">
                <el-button icon="el-icon-upload2" class="btn-base">上传本地文件</el-button>
              </el-upload>
            </el-form-item>
            <div class="el-upload__tip">支持pdf、jpg、gif、png格式；单张大小不超过10M</div>
          </template>
          <el-form-item
            label="备注"
            prop="remark"
            :rules="[
              { max: 100, message: '长度不能超过100个字符' }
            ]">
            <el-input v-model="dataForm.remark" placeholder="请输入备注"></el-input>
          </el-form-item>
        </el-form>
        <div class="more_btn">
          <p @click="submit">提交</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import NavHeader from "@/components/Header.vue"
  import {reqPath} from '../../util/global'
  import {getCookie, deepClone} from "../../util/util"
  import {getCountry} from "../../util/city"
  import { provinceAndCityData, CodeToText, TextToCode } from 'element-china-area-data'

  export default {
    name: "NovelCoronavirusEnter",
    data() {
      return {
        clientHeight: 0,
        p_showSearch: true,
        p_loginModalFlag: false,
        p_showOrNot: 'not',
        cityList: getCountry(),
        actionUrl: reqPath + `/hpv/upload/unlogin`,
        uploadHeader: {
          'token': getCookie("_token")
        },
        productList: [
          {
            value: '',
            label: 'Novel Coronavirus(2019-nCoV) Real Time Multiplex RT-PCR kit(Detection for 3 Genes)新型冠状病毒试剂盒核酸测定试剂盒（三重荧光PCR法）',
            placeholder: '预期采购数量'
          },
          {
            value: '',
            label: 'ME-0044 RNA isolation kit 核酸提取试剂盒 （自动版 ）',
            placeholder: '预期采购数量'
          },
          {
            value: '',
            label: 'ME-0010 RNA Isolation kit 核酸提取试剂盒 （手工版）',
            placeholder: '预期采购数量'
          },
          {
            value: '',
            label: 'EX3600 Automated Nucleic Acid Extraction System EX3600核酸自动提取仪',
            placeholder: '预期采购数量'
          },
          {
            value: '',
            label: '其他',
            placeholder: '预期采购产品说明'
          }
        ],
        cooperationModels: [
          {
            value: 1,
            label: '三方贸易由之江出口终端'
          },
          {
            value: 2,
            label: '采购后自行出口'
          }
        ],
        purchasingType: [
          {
            value: 1,
            label: '政府代表机构'
          },
          {
            value: 2,
            label: '进出口公司'
          },
          {
            value: 3,
            label: 'IVD代理商'
          },
          {
            value: 4,
            label: '个人'
          },
          {
            value: 5,
            label: '其他'
          }
        ],
        receivedType: [
          {
            value: 1,
            label: '政府'
          },
          {
            value: 2,
            label: '慈善组织'
          },
          {
            value: 3,
            label: 'IVD经销商'
          },
          {
            value: 4,
            label: '医院'
          },
          {
            value: 5,
            label: '第三方独立实验室'
          },
          {
            value: 6,
            label: '其他'
          },
        ],
        fileList1: [],
        fileList2: [],
        fileList3: [],
        fileList4: [],
        dataForm: {
          exportCountry: '',//预出口国家
          purchaseProducts: [],//预采购产品
          cooperationModel: '',//合作模式： 1：三方贸易由之江出口终端，2：采购后自行出口，3：暂不选择
          cgType: '', // 采购方类型
          cgCompanyName: '',//采购公司名称
          cgName: '',//采购公司联系人
          cgEmail: '',//采购公司邮箱
          cgMobile: '',//采购公司手机
          cgFile: [],//采购公司文件
          zdType: '', // 终端类型
          zdCompanyName: '',//终端公司名称
          zdName: '',//终端公司联系人
          zdMobile: '',//终端公司手机
          zdEmail: '', // 终端公司邮箱
          zdFile: [],//终端公司文件
          remark: '',//备注
          list1: [],
          list2: [],
          list3: [],
          list4: [],
          cgAddress: ''
        },
        provinceAndCityData: provinceAndCityData,
        codeToText: CodeToText,
        textToCode: TextToCode
      }
    },
    computed: {

    },
    components: {
      NavHeader
    },
    mounted() {
      setTimeout(() => {
        this.clientHeight = document.documentElement.clientHeight + 'px'
      }, 100)
    },
    methods: {
      p_showLoginModal () {
        this.p_loginModalFlag = true;
      },
      p_closeLoginModal () {
        this.p_loginModalFlag = false;
      },
      // 上传之前
      beforeUploadHandle (file) {
        if (!file.name.endsWith('pdf') && !file.name.endsWith('jpg') && !file.name.endsWith('gif') && !file.name.endsWith('png')) {
          this.$message.error('只支持pdf、jpg、gif、png格式文件！')
          return false
        }
        const isLt2M = file.size / 1024 / 1024 < 10
        if (!isLt2M) {
          this.$message.error('单张大小不超过10M!')
          return false
        }
      },
      successHandle1 (response, file, fileList) {
        if (response && response.code === 0) {
          this.dataForm.list1 = fileList
          this.$refs.dataForm.validateField(['list1'])
          this.$message({
            message: '上传成功',
            type: 'success',
            duration: 1500
          })
        }
      },
      successHandle2 (response, file, fileList) {
        if (response && response.code === 0) {
          this.dataForm.list2 = fileList
          this.$refs.dataForm.validateField(['list2'])
          this.$message({
            message: '上传成功',
            type: 'success',
            duration: 1500
          })
        }
      },
      successHandle3 (response, file, fileList) {
        if (response && response.code === 0) {
          this.dataForm.list3 = fileList
          this.$refs.dataForm.validateField(['list3'])
          this.$message({
            message: '上传成功',
            type: 'success',
            duration: 1500
          })
        }
      },
      successHandle4 (response, file, fileList) {
        if (response && response.code === 0) {
          this.dataForm.list4 = fileList
          this.$refs.dataForm.validateField(['list4'])
          this.$message({
            message: '上传成功',
            type: 'success',
            duration: 1500
          })
        }
      },
      changeProduct (e, index) {
        if (e) {
          this.productList[index].value = 1
        } else {
          this.productList[index].value = ''
        }
      },
      changeProductNum (e, index) {
        if (e >= 1) {

        } else {
          this.productList[index].value = 1
        }
      },
      submit () {
        let that = this
        let dataForm = deepClone(this.dataForm)
        //预采购产品
        let purchaseProductsStr = ''
        dataForm.purchaseProducts.map((item, index, arr) => {
          that.productList.map((_item, _index, _arr) => {
            if (item === _item.label) {
              purchaseProductsStr = purchaseProductsStr + _item.label + ':' + _item.value + ','
            }
          })
        })
        dataForm.purchaseProducts = purchaseProductsStr.substring(0, purchaseProductsStr.length-1)
        //采购公司文件
        let cgFile = []
        dataForm.list1.map((item, index, arr) => {
          cgFile.push(item.response.url)
        })
        dataForm.list2.map((item, index, arr) => {
          cgFile.push(item.response.url)
        })
        dataForm.list3.map((item, index, arr) => {
          cgFile.push(item.response.url)
        })
        dataForm.cgFile = JSON.stringify(cgFile)
        //终端公司文件
        let zdFile = []
        dataForm.list4.map((item, index, arr) => {
          zdFile.push(item.response.url)
        })
        dataForm.zdFile = JSON.stringify(zdFile)
        // 预采购所在地
        dataForm.cgAddress = this.codeToText[this.dataForm.cgAddress[0]] + '/' + this.codeToText[this.dataForm.cgAddress[1]]

        this.$refs.dataForm.validate((valid) => {
          if (valid) {
            axios.post(`/jys/questionnaire/saveForeignPurchase`,
              dataForm, {
                headers: {
                  "Content-Type": "application/json",
                  'token': getCookie("_token")
                }
              }
            ).then(({data}) => {
              if (data.code === 0) {
                this.$alert('您的申请已提交成功，我们审核通过后，会由专人与您联系，请保持电话畅通。', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                    this.$router.go(-1)
                  }
                })
              }
            })
          }
        })
      }
    }
  }
</script>

<style scoped>
  .cover{
    width: 100%;
    float: left;
    background-color: #0468c9;
  }
  .cover_in{
    width: 100%;
    margin: 0 auto;
  }
  .cover .banner{
    width: 100%;
    float: left;
  }
  .wrap{
    width: 100%;
    float: left;
    margin: 0;
    padding: 30px;
    border-radius: 10px;
    background-color: #ffffff;
    color: #131313;
    font-size: 13px;
  }
  /deep/ .el-form-item,
  /deep/ .el-form-item__content,
  /deep/ .el-select,
  /deep/ .el-cascader{
    width: 100%;
    float: left;
  }
  /deep/ .el-input{
    width: 100%;
  }
  /deep/ .el-checkbox__label{
    white-space: pre-line;
  }
  .explain_title{
    width: 100%;
    float: left;
    font-weight: bolder;
    padding-left: 10px;
    border-left: 3px solid #0468c9;
    margin-bottom: 20px;
  }
  .el-upload__tip{
    margin-bottom: 20px;
  }
  .banner-phone{
    display: block;
  }
  .banner-pc{
    display: none;
  }
  .more_btn{
    width: 100%;
    float: left;
    margin: 20px 0;
  }
  .more_btn p{
    width: 260px;
    margin: 0 auto;
    line-height: 35px;
    text-align: center;
    color: #ffffff;
    background-color: #0468c9;
    border-color: #0468c9;
  }
  .required_red{
    color: #f56c6c;
    margin-right: 4px;
  }
  @media only screen and (min-width: 600px) {
    .banner-phone{
      display: none;
    }
    .banner-pc{
      display: block;
    }
    .cover_in{
      width: 50%;
    }
    .wrap{
      margin: 40px 30px;
    }
    /deep/ .el-input{
      width: 50%;
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/activities/novel-coronavirus-enter-apply.vue